import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

const globComponents = import.meta.glob('@/components/base/**/*.vue', { eager: true })
Object.entries(globComponents).forEach(([fileName, componentConfig]) => {
  const componentName = upperFirst(
    camelCase(fileName.replace(/^.*base\//, '').replace(/\.\w+$/, '')),
  )
  Vue.component(`Base${componentName}`, componentConfig.default || componentConfig)
})
